export class PriceType {
    id?: number;
    title?: string;
    name?: string;

    static fromJson(fields: any): PriceType {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
